
const RangeThumb = ({ props }) => {
  console.log(props)
  return (
    <div
      {...props}
      className="slider-thumb"
    >
      <div className="slider-line" />
      <div className="slider-line" />
      <div className="slider-line" />
    </div>
  )
}

export default RangeThumb;
